import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  VERIFY_RESET_TOKEN_REQUEST,
  VERIFY_RESET_TOKEN_SUCCESS,
  VERIFY_RESET_TOKEN_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  SET_USER,
  CLEAR_USER,
  TOKEN_EXPIRED
} from '../constants/authConstants';


// Token validation utility
const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp > currentTime;
  } catch (error) {
    return false;
  }
};

const getInitialState = () => {
  const token = sessionStorage.getItem('authToken');
  const user = sessionStorage.getItem('user');
  
  if (token && user && isTokenValid(token)) {
    try {
      return {
        user: JSON.parse(user),
        token,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    } catch (error) {
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('user');
    }
  } else if (token) {
    // Token exists but is invalid/expired
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('user');
  }
  
  return {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    // Reset password states
    verifyTokenLoading: false,
    verifyTokenError: null,
    resetPasswordLoading: false,
    resetPasswordMessage: null,
    resetPasswordError: null
  };
};

const initialState = getInitialState();

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        token: null,
        error: action.payload
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true
      };

    case LOGOUT_SUCCESS:
    case CLEAR_USER:
    case TOKEN_EXPIRED:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        token: null,
        error: null
      };

    case SET_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true
      };

    // Reset Password Cases
    case VERIFY_RESET_TOKEN_REQUEST:
      return {
        ...state,
        verifyTokenLoading: true,
        verifyTokenError: null
      };

    case VERIFY_RESET_TOKEN_SUCCESS:
      return {
        ...state,
        verifyTokenLoading: false,
        verifyTokenError: null
      };

    case VERIFY_RESET_TOKEN_FAILURE:
      return {
        ...state,
        verifyTokenLoading: false,
        verifyTokenError: action.payload
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordMessage: null,
        resetPasswordError: null
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordMessage: action.payload,
        resetPasswordError: null
      };

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordMessage: null,
        resetPasswordError: action.payload
      };



    default:
      return state;
  }
};

export default authReducer;